import { DC_Repositories_Base_Enumerations_BusinessUnit } from '@monorepo-types/dc';
import { DC_Repositories_Base_Enumerations_Label } from '@monorepo-types/dc';
import { ResponseDataDC_Products_Client_Models_HeatProfileContext } from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetWarmthProfile = {
  label: DC_Repositories_Base_Enumerations_Label;
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  postalCode: string;
  houseNumber: number;
  houseNumberSuffix?: string;
};
/**
 * GetWarmthProfile
 * Get the heat profiles are grouped in to 5 groups
 * @returns ResponseDataDC_Products_Client_Models_HeatProfileContext Success
 */
export function getWarmthProfile(
  { label, businessUnit, postalCode, houseNumber, houseNumberSuffix }: GetWarmthProfile,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataDC_Products_Client_Models_HeatProfileContext> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/public/${businessUnit}/${label}/profile`,
      query: { postalCode, houseNumber, houseNumberSuffix },
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}
